import MediaCreateFileRequest from "@/libs/Api/Media/MediaCreateFileRequest";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Helper from "./Helper";

export default class UploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  async sendCreateFileRequest(base64) {
    let result = "";
    try {
      let _this = this;
      let createFile = new MediaCreateFileRequest(_this);
      createFile.setParams({
        fileData: base64,
        alt: "",
      });
      await createFile.fetch((response) => {
        if (response.url) {
          result = response.url;
        }
      });
    } catch (error) {
      console.error(error);
    }
    return result;
  }

  // Starts the upload process.
  async upload() {
    return new Promise((resolve, reject) => {
      const reader = new window.FileReader();
      reader.addEventListener("load", async () => {
        let pictureUrl = await this.sendCreateFileRequest(reader.result);
        let result = Helper.baseUrl + pictureUrl;
        resolve({ default: result });
      });
      reader.addEventListener("error", (err) => {
        reject(err);
      });

      reader.addEventListener("abort", () => {
        reject();
      });

      this.loader.file.then((file) => {
        reader.readAsDataURL(file);
      });
    });
  }

  // Aborts the upload process.
  abort() {
    //
  }
}
